export default function urlHasParam(url) {
    try{
        const urlObj = new URL(url);
        return urlObj.search.length > 0;
    }catch(err){
        return false
    }
}